"use strict";

var Constants = require("../designer/Constants");
var WizardConstants = require("../constants/WizardConstants");

var deviceType = Constants.DEVICE_TYPES;
var deviceMinWidth = Constants.DEVICE_MIN_WIDTHS;

var TokenExHelper = {
	getIframe: function ($parent) {
		var parentId = $parent.attr("id");
		return $parent.find(`iframe#tx_iframe_${parentId}`);
	},

	getBaseUrl: function () {
		return window.location.protocol + // http(s):
			"//" +
			window.location.hostname + // host may contain port, so play it safe and only return hostname
			(window.location.port ? ":" + window.location.port : "") // if there's a port, tack it on.
	},

	getTokenExTokenData: function ($parent) {
		var iframe = this.getIframe($parent);
		return {
			cardType: iframe.attr("data-tokenex-cardtype"),
			lastFour: iframe.attr("data-tokenex-lastfour"),
			token: iframe.attr("data-tokenex-token")
		};
	},

	initializeTokenEx: function ($parent) {
		window.addEventListener("resize", () => this._manageIframeStyling());

		$parent = $parent || $("body");
		this._generateIframe($parent);

		$parent.find("[data-component='tokenExCardNumber']").each((index, element) => {
			var $component = $(element);
			$component.attr("data-has-custom-validator", true).data({ customValidator: this.validateCardNumberToken.bind(this, $component) });
		});
	},

	isTokenEx: function (selector) {
		var $selector = $(selector || "body");
		return Boolean(
			$selector.closest("[data-component='tokenExCreditCardPayment']").length ||
			$selector.find("[data-component='tokenExCreditCardPayment']").length);
	},

	_generateIframe: function ($parent, device) {
		$parent = $parent || $("body");
		device = device || this._getDeviceType();

		var $component = $parent.find("[data-component='tokenExCardNumber']");
		var wrapperId = $component.attr("id");
		$component.attr("data-set-device", device);

		var inputStyle = decodeURIComponent($component.attr(`data-src-${device}-css`));
		var iframeStyle = decodeURIComponent($component.attr(`data-${device}-css`));

		$component.css(JSON.parse(iframeStyle));

		var authenticationKey = $component.attr("data-authentication-key");
		var timestamp = $component.attr("data-timestamp");
		var tokenExID = $component.attr("data-tokenex-id");
		var placeholder = $component.attr("inputPlaceholder");
		var fourTokenFour = "2"; // Token Scheme

		var url = this.getBaseUrl();

		var tokenExConfiguration = {
			authenticationKey,
			origin: url,
			pci: true,
			styles: {
				base: this._getStylePropertyFor(inputStyle, "base"),
				error: this._getStylePropertyFor(inputStyle, "error")
			},
			timestamp,
			tokenExID,
			tokenScheme: fourTokenFour,
			placeholder: placeholder
		};

		var tokenExIframe = window.TokenEx.Iframe(wrapperId, tokenExConfiguration);
		this._setIframeListeners(tokenExIframe, $component);
		tokenExIframe.load();
	},

	_setIframeListeners: function (tokenExIframe, $component) {
		tokenExIframe.on("error", (data) => {
			console.log(`CC iframe error: ${JSON.stringify(data)}`);
			this._removeTokenizationData($component);
			tokenExIframe.reset();
		});

		tokenExIframe.on("change", () => {
			this._removeTokenizationData($component);
		});

		tokenExIframe.on("validate", (data) => {
			console.log(`CC iframe validate: ${JSON.stringify(data)}`);
			if (!data.isValid) {
				this._removeTokenizationData($component);
				this.getIframe($component).removeAttr("isTokenizing");
			}
		});

		tokenExIframe.on("tokenize", (data) => {
			console.log(`CC iframe tokenize: ${JSON.stringify(data)}`);
			var iframe = this.getIframe($component)
			iframe.attr({
				"data-tokenex-cardtype": data.cardType,
				"data-tokenex-lastfour": data.lastFour,
				"data-tokenex-token": data.token
			});
			iframe.removeAttr("isTokenizing");
		});

		tokenExIframe.on("blur", () => {
			this.getIframe($component).attr("isTokenizing", true);
			tokenExIframe.tokenize();
		});

		tokenExIframe.on("load", () => {
			$component.removeAttr("isGeneratingIframe")
			// This handles the case where someone quickly resized from mobile to tablet to desktop.
			// The styling would get stuck on tablet because we skipped regenerating the iframe while one was already being regenerated.
			this._manageIframeStyling();
		});
	},

	_removeTokenizationData($component) {
		var iframe = this.getIframe($component)
		iframe.removeAttr("data-tokenex-token")
			.removeAttr("data-tokenex-lastfour")
			.removeAttr("data-tokenex-cardtype")
			.removeAttr("isTokenizing");
	},

	_getStylePropertyFor: function (inputString, key) {
		var startIndex = inputString.indexOf(`${key}{`) + (key.length + 1);
		var endIndex = inputString.indexOf("}", startIndex);
		return inputString.substring(startIndex, endIndex);
	},

	_manageIframeStyling: function (event, $parent) {
		if (window.AccountStore.get("isDesignMode")) {
			return;
		}

		$parent = $parent || $("body");
		var device = this._getDeviceType();

		var $components = $parent.find("[data-component='tokenExCardNumber']");
		$components.each((index, component) => {
			var $component = $(component);

			if (device !== $component.attr("data-set-device") && !$component.attr("isGeneratingIframe")) {
				// re-generate the iframe using the proper device for styling.
				$component.attr("isGeneratingIframe", true);
				this.getIframe($component).off();
				$component.empty();
				this._generateIframe($parent, device);
			}
		});
	},

	_getDeviceType: function () {
		var width = window.innerWidth;

		return (width < deviceMinWidth.TABLET && deviceType.MOBILE)
			|| (width < deviceMinWidth.DESKTOP && deviceType.TABLET)
			|| deviceType.DESKTOP;
	},

	validateCardNumberToken: function ($component) {
		var data = this.getTokenExTokenData($component);
		
		if (data && data.token) {
			return this._getValidationResponse(/*isValid:*/true);
		} else {
			if (this.getIframe($component).attr("isTokenizing")) {
				// We are going to wait for a token.
				return this._getDeferredValidationResponse($component);
			} else {
				// We did not get a token.
				return this._getValidationResponse(/*isValid:*/false);
			}
		}
	},

	_getDeferredValidationResponse: function ($component) {
		var deferred = new $.Deferred();

		window.setTimeout(() => {
			this._checkForToken($component, deferred)
		}, 500);

		return { deferred: deferred };
	},

	_getValidationResponse: function (isValid) {
		var response = { isValid: isValid, errorMessages: [] };

		if (!response.isValid) {
			var missingTokenMessage = this._getWizardErrorMessage(WizardConstants.WIZARDS.COMPANY_ERROR_MESSAGES, WizardConstants.TOKENEX_MESSAGE_FIELDS.TOKEN_MISSING);
			response.errorMessages.push(missingTokenMessage);
		}

		return response;
	},

	_checkForToken: function ($component, deferred, hasWaited) {
		var data = this.getTokenExTokenData($component);

		if (data && data.token) {
			deferred.resolve(this._getValidationResponse(/*isValid:*/true));
		} else {
			if (this.getIframe($component).attr("isTokenizing") && !hasWaited) {
				this._waitForToken(deferred, $component);
			} else {
				// We did not get a token, or we have already waited and still haven't received a token.
				deferred.resolve(this._getValidationResponse(/*isValid:*/false));
			}
		}
	},

	_waitForToken: function(deferred, $component) {
		window.setTimeout(() => {
			this._checkForToken($component, deferred, /*hasWaited:*/true)
		}, 5000);
	},

	_getWizardErrorMessage: function (wizardName, wizardField) {
		if (window.CheckoutActions) {
			return window.CheckoutActions.getWizardValue(wizardName, wizardField);
		}

		return window.AccountStore.getWizardValue(wizardName, wizardField);
	}
};

module.exports = TokenExHelper;
